import React from 'react';
import '../styles/PromoStrip.scss';
const defaultProps = {
  url: '',
  linkText: '',
  leftSideMediaUrl: '',
  rightSideMediaUrl: '',
  leftSideMediaFileName: '',
  rightSideMediaFileName: ''
};
const PromoStrip = _ref => {
  let {
    content,
    url,
    backgroundColour,
    linkText,
    leftSideMediaUrl,
    rightSideMediaUrl,
    leftSideMediaFileName,
    rightSideMediaFileName
  } = _ref;
  const stripColourStyling = `text contentful-${backgroundColour ? backgroundColour.toLowerCase().replace(' ', '-') : ''}`;
  const promoStripContentContainer = () => {
    if (leftSideMediaUrl || rightSideMediaUrl) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, leftSideMediaUrl && /*#__PURE__*/React.createElement("img", {
        "data-testid": "left-img",
        className: "image left-side-image",
        alt: leftSideMediaFileName,
        src: leftSideMediaUrl
      }), /*#__PURE__*/React.createElement("div", {
        className: "promo-strip-image-content"
      }, content, url && /*#__PURE__*/React.createElement("a", {
        "data-testid": "promo-link",
        className: "btn btn-primary outline reference-card-button",
        href: url
      }, linkText)), rightSideMediaUrl && /*#__PURE__*/React.createElement("img", {
        "data-testid": "right-img",
        className: "image right-side-image",
        alt: rightSideMediaFileName,
        src: rightSideMediaUrl
      }));
    } else if (url && !leftSideMediaUrl && !rightSideMediaUrl) {
      return /*#__PURE__*/React.createElement("a", {
        "data-testid": "promo-link",
        href: url
      }, content);
    } else {
      return /*#__PURE__*/React.createElement(React.Fragment, null, content);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "promo-strip",
    className: `promo-strip ${stripColourStyling}`
  }, /*#__PURE__*/React.createElement("div", {
    className: "promo-strip-content-container"
  }, promoStripContentContainer()));
};
PromoStrip.defaultProps = defaultProps;
export { PromoStrip };